import React from 'react';
import PropTypes from "prop-types";

import MindsetsJsSDK from "../../index";
import Autocomplete from "./Autocomplete";
import DistrictDropdownItem from "./DistrictDropdownItem";
import {EXPRESSION_CONTAINS, EXPRESSION_EQUAL} from "../../constants/filter";

function DistrictDropdown(
    {
        id,
        default_value,
        placeholder = 'District name',
        container_class,
        input_class,
        country,
        state,
        show_add_always = false,
        label,
        label_class,
        renderAdd,
        onSelect,
        with_reset = false,
        disabled = false,
        onReset,
        match_dropdown_width = false
    }
) {
    function getDistricts(name) {
        let options = {}
        options['filters[name][0]'] = EXPRESSION_CONTAINS + '=' + name;
        if (country) {
            options['filters[country][0]'] = EXPRESSION_EQUAL + '=' + country;
        }
        if (state) {
            options['filters[state][0]'] = EXPRESSION_EQUAL + '=' + state;
        }

        return MindsetsJsSDK().API.get('districts', options).then(response => response.items);
    }

    return (
        <Autocomplete
            id={id}
            placeholder={placeholder}
            fetchItems={getDistricts}
            onSelect={onSelect}
            label={label}
            label_class={label_class}
            renderItem={item => <DistrictDropdownItem item={item}/>}
            default_value={default_value}
            persist_value={true}
            always_show_add={show_add_always}
            renderAdd={renderAdd}
            container_class={container_class}
            input_class={input_class}
            with_reset={with_reset}
            onReset={onReset}
            disabled={disabled} match_dropdown_width={match_dropdown_width}
        />
    );
}

DistrictDropdown.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    default_value: PropTypes.string,
    placeholder: PropTypes.string,
    container_class: PropTypes.string,
    input_class: PropTypes.string,
    country: PropTypes.string,
    state: PropTypes.string,
    show_add_always: PropTypes.bool,
    label: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.object,
        PropTypes.element,
    ]),
    label_class: PropTypes.string,
    renderAdd: PropTypes.func,
    onSelect: PropTypes.func.isRequired,
    with_reset: PropTypes.bool,
    disabled: PropTypes.bool,
    onReset: PropTypes.func,
    match_dropdown_width: PropTypes.bool
};

export default DistrictDropdown;
